<template>
  <div class="piclist-upload overflow-hidden">
    <ul class="overflow-hidden">
      <li v-for="(pic,index) in pics" v-if="index<max_count" class="float-left">
        <img :src="pic.url" alt="" @click="scan(pic)">
        <div class="mask" v-if="pic.status!='end'">
          {{ pic.progress }}%
        </div>
      </li>
      <li class="float-left" v-if="pics.length<max_count">
        <img @click="selectFile" src="../../static/img/添加图片.png" alt="">
      </li>
      <li class="float-left" v-if="pics.length==0">
        <span v-if="!label">添加图片</span>
        <span v-else>{{ label }}</span>
        <span v-if="!description">请上传患处图片,让医生更了解您的{{ isTeam ? "情况" : "病情" }}</span>
        <span v-else>{{ description }}</span>
      </li>
    </ul>
    <input ref="input" type="file" @change="change" :multiple="multiple" accept="image/*">
  </div>
</template>

<script>
import {arrayFind, getVersionFromUA, isAndroid, versionEgt} from "../lib/util";
import readFile from "../utils/readfile"
import uploadApi from "../lib/uploadApi"
import weuijs from 'weui.js'

const MAX_COUNT = 9;
//pics[{id,status,url,progress,file}]
export default {
  name: 'piclist-upload',
  props: {
    max_count: {
      type: Number,
      default: MAX_COUNT
    },
    label: String,
    description: String,
    isTeam: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      pics: [],
      start: 0,
      multiple: true
    };
  },
  computed: {},
  components: {},
  created() {
    let version = getVersionFromUA();
    console.log(version, versionEgt(version, '10.0.0'));
    if (isAndroid() && version && versionEgt(version, '10.0.0') === false) this.multiple = false;
  },
  mounted() {
  },
  beforeDestroy() {
  },
  watch: {
    pics(newV) {
      this.$emit('uploaded', newV);
    }
  },
  methods: {
    scan(pic) {
      let gallery = weuijs.gallery(pic.url, {
        onDelete: () => {
          weuijs.confirm('确定删除该图片？', () => {
            let index = this.pics.findIndex((res) => {
              return res.file == pic.file;
            });
            gallery.hide(() => {
              this.pics.splice(index, 1);
            });
          })
        }
      });
    },
    selectFile() {
      this.$refs.input.click();
    },
    change() {
      let el = this.$refs.input,
        files = el.files;
      if (files.length > this.max_count) {
        this.$weuijs.alert("最多上传" + this.max_count + "张");
        return false;
      } else {
        this.doUpload(files);
      }
    },

    setDefaultPics(pics) {
      this.pics.splice(0);
      this.pics = pics;
    },

    async doUpload(files) {
      this.$emit("status", 'queue');
      await this.addQueue(files);
      await this.uploadQueue(files);
    },

    async uploadQueue(files) {
      this.$emit("status", 'loading');
      if (this.pics.length > MAX_COUNT) {
        return
      }
      for (let i = 0; i < files.length; i++) {
        let file = files[i],
          pic = arrayFind(this.pics, (res) => {
            return res.file == file;
          }),
          index = this.pics.findIndex((res) => {
            return res.file == file;
          }),
          ret = await uploadApi(file, (progress) => {
            let {loaded, total} = progress;
            let pro = parseFloat(loaded / total);
            pro = Math.round(parseFloat(pro.toFixed(2)) * 100);
            pic.progress = pro;
            this.pics.splice(index, 1, pic);
          });
        Log('ret', ret);
        if (ret.code == 0) {
          pic.url = ret.obj.url;
          pic.status = "end";
          pic.id = ret.obj.attaId;
          this.pics.splice(index, 1, pic);
        }
      }
      this.$emit("status", 'loaded');
    },

    async addQueue(files) {
      for (let i = 0; i < files.length; i++) {
        let res = await readFile(files[i]);
        if (this.pics.length >= MAX_COUNT) {
          return
        }
        this.pics.push({
          file: files[i],
          url: res,
          status: 'start',
          progress: 0
        })
      }
      return this.pics;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/public";

.piclist-upload {
  position: relative;

  input {
    position: absolute;
    left: 1000px;
    top: 1000px;
  }

  ul {
    $w: px2rem(75px);

    li {
      position: relative;
      padding-right: px2rem(10px);
      padding-bottom: px2rem(10px);

      img {
        width: $w;
        height: $w;
      }

      .mask {
        background-color: rgba(0, 0, 0, 0.5);
        color: white;
        line-height: $w;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;
        width: $w;
        height: $w;
        @include t_r_b_l();
      }

      span {
        padding-top: px2rem(8px);
        color: #777777;
        display: block;
        font-size: 12px;

        &:first-child {
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/piclist-upload.vue